import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import AdminLayout from "../components/admin/AdminLayout";
import ProtectedRoute from "../components/admin/ProtectedRoute";
import AdminLoginPage from "../pages/AdminLoginPage";
import ESSDashboardPage from "../pages/admin/ess/ESSDashboardPage";
import ESSProfilePage from "../pages/admin/ess/ESSProfilePage";
import ESSLeavesPage from "../pages/admin/ess/ESSLeavesPage";
import ESSAttendancePage from "../pages/admin/ess/ESSAttendancePage";
import ESSTimesheetsPage from "../pages/admin/ess/ESSTimesheetsPage";
import ESSPayslipsPage from "../pages/admin/ess/ESSPayslipsPage";
import ESSExpensesPage from "../pages/admin/ess/ESSExpensesPage";
import ESSLoansPage from "../pages/admin/ess/ESSLoansPage";
import ESSSalaryAdvancesPage from "../pages/admin/ess/ESSSalaryAdvancesPage";
import ESSAppraisalsPage from "../pages/admin/ess/ESSAppraisalsPage";
import ESSTrainingPage from "../pages/admin/ess/ESSTrainingPage";
import ESSAnnouncementsPage from "../pages/admin/ess/ESSAnnouncementsPage";
import ESSDocumentsPage from "../pages/admin/ess/ESSDocumentsPage";
import ESSAdminEmployeesPage from "../pages/admin/ess/ESSAdminEmployeesPage";
import ESSAdminRecruitmentPage from "../pages/admin/ess/ESSAdminRecruitmentPage";
import ESSAdminSettingsPage from "../pages/admin/ess/ESSAdminSettingsPage";
import AdminPanelLayout from "../pages/admin-panel/AdminPanelLayout";
import AdminPanelDashboardPage from "../pages/admin-panel/pages/AdminPanelDashboardPage";
import AdminPanelOrgPage from "../pages/admin-panel/pages/AdminPanelOrgPage";
import AdminPanelLeavesPage from "../pages/admin-panel/pages/AdminPanelLeavesPage";
import AdminPanelAttendancePage from "../pages/admin-panel/pages/AdminPanelAttendancePage";
import AdminPanelExpensesPage from "../pages/admin-panel/pages/AdminPanelExpensesPage";
import AdminPanelPayslipsPage from "../pages/admin-panel/pages/AdminPanelPayslipsPage";
import AdminPanelAppraisalsPage from "../pages/admin-panel/pages/AdminPanelAppraisalsPage";
import AdminPanelTrainingPage from "../pages/admin-panel/pages/AdminPanelTrainingPage";
import AdminPanelDocumentsPage from "../pages/admin-panel/pages/AdminPanelDocumentsPage";
import AdminPanelAnnouncementsPage from "../pages/admin-panel/pages/AdminPanelAnnouncementsPage";
import AdminPanelSettingsPage from "../pages/admin-panel/pages/AdminPanelSettingsPage";
import AdminPanelSalesOrdersPage from "../pages/admin-panel/pages/AdminPanelSalesOrdersPage";
import AdminPanelSalesInvoicesPage from "../pages/admin-panel/pages/AdminPanelSalesInvoicesPage";
import SalesOrderDetailPage from "../pages/admin-panel/pages/sell-v2/SalesOrderDetailPage";
import CustomerInvoiceDetailPage from "../pages/admin-panel/pages/sell-v2/CustomerInvoiceDetailPage";
import AdminPanelPurchaseOrdersPage from "../pages/admin-panel/pages/AdminPanelPurchaseOrdersPage";
import AdminPanelProductsPage from "../pages/admin-panel/pages/AdminPanelProductsPage";
import AdminPanelStockPage from "../pages/admin-panel/pages/AdminPanelStockPage";
import AdminPanelMovesPage from "../pages/admin-panel/pages/AdminPanelMovesPage";
import AdminPanelWarehousesPage from "../pages/admin-panel/pages/AdminPanelWarehousesPage";
import AdminPanelAccountsPage from "../pages/admin-panel/pages/AdminPanelAccountsPage";
import AdminPanelJournalPage from "../pages/admin-panel/pages/AdminPanelJournalPage";
import AdminPanelLedgerPage from "../pages/admin-panel/pages/AdminPanelLedgerPage";
import AdminPanelVendorBillsPage from "../pages/admin-panel/pages/AdminPanelVendorBillsPage";
import AdminPanelAgingPage from "../pages/admin-panel/pages/AdminPanelAgingPage";
import AdminPanelPeriodsPage from "../pages/admin-panel/pages/AdminPanelPeriodsPage";
import AdminPanelAccountMovesPage from "../pages/admin-panel/pages/AdminPanelAccountMovesPage";
import AdminPanelPaymentsPage from "../pages/admin-panel/pages/AdminPanelPaymentsPage";
import AdminPanelReconciliationPage from "../pages/admin-panel/pages/AdminPanelReconciliationPage";
import AdminPanelReportsPage from "../pages/admin-panel/pages/AdminPanelReportsPage";
import AdminPanelCrmPage from "../pages/admin-panel/pages/AdminPanelCrmPage";
import AdminPanelCrmV2Page from "../pages/admin-panel/pages/AdminPanelCrmV2Page";
import AdminPanelCrmDashboardPage from "../pages/admin-panel/pages/AdminPanelCrmDashboardPage";
import AdminPanelCrmSettingsPage from "../pages/admin-panel/pages/AdminPanelCrmSettingsPage";
import AdminPanelPartnersPage from "../pages/admin-panel/pages/AdminPanelPartnersPage";
import { ErrorPage, UnknowErrorPage } from "../components";
import {
    About,
    Blog,
    BlogCategory,
    BlogDetail,
    Home,
    Product,
    Products,
    Service,
    ServiceDetail,
    SliderPage,
    HyteraPage,
    BodyWornCameraSolution,
    RandD,
    DynamicRandD,
    Industries,
    DynamicIndustries,
    Company,
    Companies,
    DynamicCompany,
    DynamicService,
    Services,
    News,
    NewsDetail,
    RandDPage,
    IndustryPage,
    CompanyPage,
    ServicePage,
    DomainPage,
    Faq,
    
} from "../pages";
import ContactPage from "../pages/ContactPage";
import PartnersPage from "../pages/PartnersPage";
import BlogPage from "../pages/BlogPage";
import NewsPage from "../pages/NewsPage";
import BlogDetailPage from "../pages/BlogDetailPage";
import NewsDetailPage from "../pages/NewsDetailPage";
import SubMenuPage from "../pages/SubMenuPage";
import ProductPage from "../pages/ProductPage";
import CareerPage from "../pages/CareerPage";
import HomeErrorBoundary from "../pages/HomeErrorBoundary";

const router = createBrowserRouter([
    {
        path: "/admin/login",
        element: <AdminLoginPage />,
    },
    {
        path: "/admin-panel",
        element: (
            <ProtectedRoute>
                <AdminPanelLayout />
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <Navigate to="dashboard" replace />,
            },
            {
                path: "dashboard",
                element: <AdminPanelDashboardPage />,
            },
            {
                path: "employees",
                element: <ESSAdminEmployeesPage />,
            },
            {
                path: "org",
                element: <AdminPanelOrgPage />,
            },
            {
                path: "leaves",
                element: <AdminPanelLeavesPage />,
            },
            {
                path: "attendance",
                element: <AdminPanelAttendancePage />,
            },
            {
                path: "expenses",
                element: <AdminPanelExpensesPage />,
            },
            {
                path: "payslips",
                element: <AdminPanelPayslipsPage />,
            },
            {
                path: "recruitment",
                element: <ESSAdminRecruitmentPage />,
            },
            {
                path: "appraisals",
                element: <AdminPanelAppraisalsPage />,
            },
            {
                path: "training",
                element: <AdminPanelTrainingPage />,
            },
            {
                path: "documents",
                element: <AdminPanelDocumentsPage />,
            },
            {
                path: "announcements",
                element: <AdminPanelAnnouncementsPage />,
            },
            {
                path: "settings",
                element: <AdminPanelSettingsPage />,
            },
            {
                path: "sales",
                element: <AdminPanelSalesOrdersPage />,
            },
            {
                path: "sales/invoices",
                element: <AdminPanelSalesInvoicesPage />,
            },
            {
                path: "sales/invoices/:id",
                element: <CustomerInvoiceDetailPage />,
            },
            {
                path: "sales/:id",
                element: <SalesOrderDetailPage />,
            },
            {
                path: "purchases",
                element: <AdminPanelPurchaseOrdersPage />,
            },
            {
                path: "products",
                element: <AdminPanelProductsPage />,
            },
            {
                path: "stock",
                element: <AdminPanelStockPage />,
            },
            {
                path: "stock/moves",
                element: <AdminPanelMovesPage />,
            },
            {
                path: "stock/warehouses",
                element: <AdminPanelWarehousesPage />,
            },
            {
                path: "accounts",
                element: <AdminPanelAccountsPage />,
            },
            {
                path: "journal",
                element: <AdminPanelJournalPage />,
            },
            {
                path: "ledger",
                element: <AdminPanelLedgerPage />,
            },
            {
                path: "vendor-bills",
                element: <AdminPanelVendorBillsPage />,
            },
            {
                path: "aging",
                element: <AdminPanelAgingPage />,
            },
            {
                path: "periods",
                element: <AdminPanelPeriodsPage />,
            },
            {
                path: "moves/account",
                element: <AdminPanelAccountMovesPage />,
            },
            {
                path: "payments",
                element: <AdminPanelPaymentsPage />,
            },
            {
                path: "reconciliation",
                element: <AdminPanelReconciliationPage />,
            },
            {
                path: "reports",
                element: <AdminPanelReportsPage />,
            },
            {
                path: "crm",
                element: <AdminPanelCrmV2Page />,
            },
            {
                path: "crm/v2",
                element: <Navigate to="/admin-panel/crm" replace />,
            },
            {
                path: "crm/legacy",
                element: <AdminPanelCrmPage />,
            },
            {
                path: "crm/customers",
                element: <AdminPanelPartnersPage />,
            },
            {
                path: "crm/dashboard",
                element: <AdminPanelCrmDashboardPage />,
            },
            {
                path: "crm/settings",
                element: <AdminPanelCrmSettingsPage />,
            },
        ],
    },
    {
        path: "/admin",
        element: (
            <ProtectedRoute>
                <AdminLayout />
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <Navigate to="dashboard" replace />,
            },
            {
                path: "dashboard",
                element: <ESSDashboardPage />,
            },
            {
                path: "profile",
                element: <ESSProfilePage />,
            },
            {
                path: "leaves",
                element: <ESSLeavesPage />,
            },
            {
                path: "attendance",
                element: <ESSAttendancePage />,
            },
            {
                path: "timesheets",
                element: <ESSTimesheetsPage />,
            },
            {
                path: "payslips",
                element: <ESSPayslipsPage />,
            },
            {
                path: "expenses",
                element: <ESSExpensesPage />,
            },
            {
                path: "loans",
                element: <ESSLoansPage />,
            },
            {
                path: "salary-advances",
                element: <ESSSalaryAdvancesPage />,
            },
            {
                path: "appraisals",
                element: <ESSAppraisalsPage />,
            },
            {
                path: "training",
                element: <ESSTrainingPage />,
            },
            {
                path: "announcements",
                element: <ESSAnnouncementsPage />,
            },
            {
                path: "documents",
                element: <ESSDocumentsPage />,
            },
            {
                path: "employees",
                element: <ESSAdminEmployeesPage />,
            },
            {
                path: "recruitment",
                element: <ESSAdminRecruitmentPage />,
            },
            {
                path: "settings",
                element: <ESSAdminSettingsPage />,
            },
        ],
    },
    {
        path: "/",
        element: <App />,
        // errorElement: <ErrorPage />,
        ErrorBoundary: () => <UnknowErrorPage />,
        children: [
            {
                index: true,
                element: <HyteraPage />,
                ErrorBoundary: () => <HomeErrorBoundary />,
            },
            {
                path: "services",
                element: <Service />,
            },
            {
                path: "fr/services",
                element: <Service />,
            },
            {
                path: "products",
                element: <Product />,
            },
            {
                path: "produits",
                element: <Product />,
            },
            {
                path: "fr/products",
                element: <Product />,
            },
            {
                path: "info/produits",
                element: <Products />,
            },
            {
                path: "fr/info/produits",
                element: <Products />,
            },
            {
                path: "info/services",
                element: <Services />,
            },
            {
                path: "fr/info/services",
                element: <Services />,
            },
            {
                path: "info/companies",
                element: <Companies />,
            },
            {
                path: "fr/info/companies",
                element: <Companies />,
            },
            {
                path: "about",
                element: <About />,
            },
            {
                path: "a-propos",
                element: <About />,
            },
            {
                path: "fr/about",
                element: <About />,
            },
            {
                path: "contact",
                element: <ContactPage />,
            },
            {
                path: "fr/contact",
                element: <ContactPage />,
            },
            {
                path: "news",
                element: <NewsPage />,
            },
            {
                path: "actualites",
                element: <NewsPage />,
            },
            {
                path: "fr/news",
                element: <NewsPage />,
            },
            {
                path: "blog",
                element: <BlogPage />,
            },
            {
                path: "fr/blog",
                element: <BlogPage />,
            },
            // {
            //     path: "en/connect",
            //     element: <BlogPage />,
            // },
            {
                path: "partners",
                element: <PartnersPage />,
            },
            {
                path: "fr/partners",
                element: <PartnersPage />,
            },
            // {
            //     path: "blog/categories/:slug",
            //     element: <BlogCategory />,
            // },
            // {
            //     path: "fr/blog/categories/:slug",
            //     element: <BlogCategory />,
            // },
            {
                path: "blog/:slug",
                element: <BlogDetailPage />,
            },
            // {
            //     path: "fr/blog/:slug",
            //     element: <BlogDetailPage />,
            // },
            {
                path: "news/:slug",
                element: <NewsDetailPage />,
            },
            // {
            //     path: "actualites/:slug",
            //     element: <NewsDetailPage />,
            // },
            // {
            //     path: "service/:slug",
            //     element: <ServiceDetail />,
            // },
            // {
            //     path: "fr/service/:slug",
            //     element: <ServiceDetail />,
            // },
            // {
            //     path: "info/produits/body-worn-camera-solution",
            //     element: <BodyWornCameraSolution />,
            // },
            {
                path: "info/produits/:slug",
                element: <ProductPage />,
            },
            {
                path: "info/r-and-d",
                element: <RandD />,
            },
            {
                path: "fr/info/r-and-d",
                element: <RandD />,
            },
            {
                path: "info/r-and-d/:slug",
                element: <RandDPage />,
            },
            {
                path: "fr/info/r-and-d/:slug",
                element: <RandDPage />,
            },
            {
                path: "info/industries",
                element: <Industries />,
            },
            {
                path: "fr/info/industries",
                element: <Industries />,
            },
            {
                path: "info/industries/:slug",
                element: <IndustryPage />,
            },
            {
                path: "fr/info/industries/:slug",
                element: <IndustryPage />,
            },
            {
                path: "info/industries",
                element: <Industries />,
            },
            {
                path: "fr/info/industries",
                element: <Industries />,
            },
            {
                path: "info/company",
                element: <Company />,
            },
            {
                path: "fr/info/company",
                element: <Company />,
            },
            {
                path: "info/company/:slug",
                element: <CompanyPage />,
            },
            {
                path: "fr/info/company/:slug",
                element: <CompanyPage />,
            },
            {
                path: "info/services",
                element: <Services />,
            },
            {
                path: "fr/info/services",
                element: <Services />,
            },
            {
                path: "info/services/:slug",
                element: <ServicePage />,
            },
            {
                path: "fr/info/services/:slug",
                element: <ServicePage />,
            },
            {
                path: "info/produits/:slug",
                element: <ProductPage />,
            },
            {
                path: "fr/info/produits/:slug",
                element: <ProductPage />,
            },
            {
                path: "info/domain/:slug",
                element: <DomainPage />,
            },
            {
                path: "fr/info/domain/:slug",
                element: <DomainPage />,
            },
            {
                path: "info/domaine/:slug",
                element: <DomainPage />,
            },
            {
                path: "fr/info/domaine/:slug",
                element: <DomainPage />,
            },
            {
                path: "careers",
                element: <CareerPage />,
            },
            {
                path: "fr/carrieres",
                element: <CareerPage />,
            },
            {
                path: "faq",
                element: <Faq />,
            },
            {
                path: "fr/faq",
                element: <Faq />,
            },
            // {
            //     path: "documentation",
            //     element: <Documentation />,
            // },
            // {
            //     path: "fr/documentation",
            //     element: <Documentation />,
            // },
            // {
            //     path: "training",
            //     element: <Training />,
            // },
            // {
            //     path: "fr/formation",
            //     element: <Training />,
            // },
            // {
            //     path: "info/:slug/:slug",
            //     element: <SubMenuPage />,
            // },
            // {
            //     path: "fr/info/:slug/:slug",
            //     element: <SubMenuPage />,
            // },

            // {
            //     path: "sub/:slug/:slug/:slug",
            //     element: <SubMenuPage />,
            // },
            // {
            //     path: "fr/sub/:slug/:slug/:slug",
            //     element: <SubMenuPage />,
            // },
            // {
            //     path: "slider/:slug",
            //     element: <SliderPage />,
            // },
            // {
            //     path: "fr/slider/:slug",
            //     element: <SliderPage />,
            // },
            // {
            //     path: "hytera",
            //     element: <HyteraPage />,
            // },
            {
                path: "*",
                element: <ErrorPage />,
            },
        ],
    },
]);

export default router;
